export enum views {
  mobile = 'mobile',
  tablet = 'tablet',
  desktop = 'desktop',
}

export function determineLayoutBasedOnWindowWidth(window: Window) {
  const width = window.innerWidth;
  const mobileMinWidth = 768;
  const tabletMinWidth = 1024;

  let view;

  if (width < mobileMinWidth) {
    view = views.mobile;
  } else if (width < tabletMinWidth) {
    view = views.tablet;
  } else {
    view = views.desktop;
  }

  return view;
}
